import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const EMPTY = {
  raison_sociale: "", secteur: "", ville: "", departement: "", adresse: "", code_postal: "",
  site_internet: "", telephone: "", email_generique: "", contact_prenom: "", contact_nom: "",
  contact_fonction: "", contact_email: "", besoin_potentiel: "", commentaire: "",
};

export const AddProspectDialog = ({ open, onClose, onAdded }) => {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/prospects", form);
      toast.success("Prospect ajouté");
      setForm(EMPTY);
      onAdded?.();
      onClose();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] max-w-xl overflow-y-auto" data-testid="add-prospect-dialog">
        <DialogHeader><DialogTitle className="font-display">Ajouter un prospect</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div><Label>Raison sociale *</Label><Input required className="mt-1" value={form.raison_sociale} onChange={set("raison_sociale")} data-testid="prospect-name-input" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Secteur</Label><Input className="mt-1" value={form.secteur} onChange={set("secteur")} data-testid="prospect-sector-input" /></div>
            <div><Label>Ville</Label><Input className="mt-1" value={form.ville} onChange={set("ville")} data-testid="prospect-city-input" /></div>
            <div><Label>Département</Label><Input className="mt-1" value={form.departement} onChange={set("departement")} /></div>
            <div><Label>Site internet</Label><Input className="mt-1" value={form.site_internet} onChange={set("site_internet")} /></div>
            <div><Label>Téléphone</Label><Input className="mt-1" value={form.telephone} onChange={set("telephone")} /></div>
            <div><Label>E-mail générique</Label><Input className="mt-1" value={form.email_generique} onChange={set("email_generique")} data-testid="prospect-email-input" /></div>
            <div><Label>Prénom contact</Label><Input className="mt-1" value={form.contact_prenom} onChange={set("contact_prenom")} /></div>
            <div><Label>Nom contact</Label><Input className="mt-1" value={form.contact_nom} onChange={set("contact_nom")} /></div>
            <div><Label>Fonction</Label><Input className="mt-1" value={form.contact_fonction} onChange={set("contact_fonction")} /></div>
            <div><Label>E-mail du contact</Label><Input className="mt-1" value={form.contact_email} onChange={set("contact_email")} /></div>
          </div>
          <div><Label>Besoin potentiel identifié</Label><Input className="mt-1" value={form.besoin_potentiel} onChange={set("besoin_potentiel")} data-testid="prospect-need-input" /></div>
          <div><Label>Commentaire</Label><Textarea rows={2} className="mt-1" value={form.commentaire} onChange={set("commentaire")} /></div>
          <Button type="submit" disabled={busy} className="w-full" data-testid="prospect-submit-button">{busy ? "Ajout…" : "Ajouter le prospect"}</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
